import React, {
  useState,
  useRef,
  useEffect,
  useContext,
} from "react";
import { v4 as uuid } from "uuid";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { cloneDeep } from "lodash";
import { useGesture } from "@use-gesture/react";
import { animated, useSpring } from "react-spring";
import { useApolloClient, useQuery } from "@apollo/client";

import { useAuthContext } from "../providers/AuthProvider";
import { InfoDndContext } from "../context/InfoDndContext";
import { GET_COUNT_PER_DAY_EMPLOYEE } from "../graphql/querys";
import Card from "./Booking/Card";
import { CurrentDateContext } from "../context/CurrentDateContext";

const SCROLL_THRESHOLD = 50;
const SCROLL_SPEED = 15;
const K_MAX_BLOQUES = 24;

const items = [];

// const divContenedor = document.getElementById('contenedorAgenda');
// const divContenedorAgendaHeader = document.getElementById('contenedorAgendaHeader');

// if(divContenedor){
//   divContenedor.addEventListener('scroll', function () {
//     divContenedorAgendaHeader.scrollLeft = divContenedor.scrollLeft;
//   });
// }


const procesarNotificaciones = (toast, res)=>{


  console.log("procesarNotificaciones", res)


  if(res==-1){
    const notify = () =>
      toast("Reservations cannot be moved past closing", {
        icon: "⚠️",
      });
    notify();            
  }

  if(res==-2){
    const notify = () =>
      toast("Booking collision!", {
        icon: "⚠️",
      });
    notify();   
  }

}

const quantizeBy = (value, quantize) => {

      const x= Math.round( value[0] / quantize) * quantize
      const y= Math.round( value[1] / quantize) * quantize




      return [x,y];
}



const checkOverlap2 = (itemPropuesto, driver, newDriver, id, calendario) => {

  const filled = calendario.find(
    (driverReservas) => driverReservas.driver === newDriver
  ).reservas;

  const driverReservas = filled.filter(
    (reserva) => reserva.type === "used" && reserva.id !== id
  );

  const { from, duration } = itemPropuesto;
  const endOrigin = from + duration;

  if (endOrigin > K_MAX_BLOQUES) {
    // const notify = () =>
    //   toast("Reservations cannot be moved past closing", {
    //     icon: "⚠️",
    //   });
    // notify();
    return -1;
  }

  const fullTest = driverReservas.filter((i) => {
    const f = i.from;
    const t = i.from + i.duration;
    // is  "from" between  f and t ?
    return (
      (f <= from && t > from) ||
      (f < endOrigin && t > endOrigin) ||
      (f > from && t < endOrigin) ||
      (f > from && t <= endOrigin)
    );
  });


  // console.log("here");
  if (fullTest.length) {
    // const notify = () =>
    //   toast("Booking collision!", {
    //     icon: "⚠️",
    //   });
    // notify();
    return -2;
  }

  return 0;
}



const checkOnTheFly = (rowPropuesto,calendario)=>{

    try{
      let test;
      if( checkOverlap2(
        {
          from: rowPropuesto.newFrom,
          duration: rowPropuesto.item.duration,
        },
        rowPropuesto.item.driver,
        calendario[rowPropuesto.newDriverIndex].driver,
        rowPropuesto.item.id,
        calendario
      )!==0)return false;
  
      let fail = false;
  
      rowPropuesto.item.driversAdicionales.map((i) => {
  
        if(fail)return false;
  
        // console.log("checkOnTheFly", i)
          const res = checkOverlap2(
            {
              from: rowPropuesto.newFrom,
              duration: rowPropuesto.item.duration,
            },
            rowPropuesto.item.driver,
            i.name,
            rowPropuesto.item.id,
            calendario
          );
      
          if(res<0)fail = true
  
      });
  
      return !fail;
    }catch(e){
      console.log("checkOnTheFly error", e)
      alert("checkOnTheFly error")
    }

    return false;
}





const marcadorDeBoatCollisions = (dataIn) => {
  // console.log("marcadorDeBoatCollisions", dataIn)

  const groupedData = {};

  dataIn.forEach((item) => {
    if (!groupedData[item.boatName]) {
      groupedData[item.boatName] = [];
    }
    if (item.boatName) {
      groupedData[item.boatName].push(item);
    }
  });

  const result = Object.values(groupedData);

  const colisiones = [];

  const aaa = result.forEach((grupoBotes) => {
    grupoBotes.forEach((item, index) => {
      // console.log(`marcadorDeBoatCollisions grupoBotes`, grupoBotes)
      // console.log(`marcadorDeBoatCollisions COMPARING:${item.id}  from:${item.from}  to:${item.from+item.duration}`)

      grupoBotes.map((i) => {
        const dstFrom = i.from;
        const dstTo = i.from + i.duration;

        const test =
          item.from + item.duration > i.from &&
          item.from < i.from + i.duration;

        const colision = test && item.id !== i.id;
        if (colision)
          if (!colisiones.includes(item.id)) colisiones.push(item.id);
        // console.log(`marcadorDeBoatCollisions ${item.boatName} WITH:${item.id}  from:${dstFrom}  to:${dstTo}:  ${colision?i.id:'FALSE'}   `)
      });
    });
  });

  // console.log("marcadorDeBoatCollisions colisiones", colisiones)

  return dataIn.map((item) => {
    if (colisiones.includes(item.id))
      return { ...item, colision: true };
    return { ...item, colision: false };
  });

  // const force = dataIn.map((item) => {
  //   if (colisiones.includes(item.id))
  //     return { ...item, colision: true };
  //   return { ...item, colision: false };
  // });

  // const focus = force.map((i) => {
  //   if (i.type === "blank") return { ...i, id: uuid() };
  //   else return i;
  // });
  // console.log({ focus });

  // return force.map((i) => {
  //   if (i.type === "blank") return { ...i, id: uuid() };
  //   else return i;
  // });
};

const fillColumn = (bloques, cant, quantize, driver) => {
  const filled = [];

  for (let a = 0; a < cant; a++) {
    const block = bloques.find((b) => b.from === a);

    if (block) {
      filled.push(block);
      a = a + block.duration - 1;
    } else {
      filled.push({
        driverObj: driver.driverObj,
        from: a,
        duration: quantize,
        type: "blank",
        id: uuid(),
      });
    }
  }

  return filled;
};

let reservasInitial = [];

function DraggableItem({
  opacity,
  children,
  fastAdd,
  height,
  item,
  onMoveStart,
  onMoveEnd,
  containerRef,
  bgColor,
  setIsScrolling,
  setElementCoords,
  principalContentRef,
}) {
  const [underTap, setUnderTap] = useState(false);
  const divContenedor = document.getElementById("contenedorAgenda");
  const divContenedorRoot = window; //getElementById('root');

  const [leftScrollOnInit, setLeftScrollOnInit] = useState(0);
  const [topScrollOnInit, setTopScrollOnInit] = useState(0);

  const [scrolling, setScrolling] = useState(null);
  const [scrollControl, setScrollControl] = useState({
    active: false,
  });

  const [dimensionesCaja, setDimensionesCaja] = useState({
    w: 0,
    h: 0,
  });

  const [isDragging, setIsDragging] = useState(false);
  const [layer, setLayer] = useState(1);
  const itemRef = useRef(null);
  const [rowIndex, setRowIndex] = useState(null);
  const rowHeight = 1 / 12; // altura de fila en fracciones de la altura total
  const [{ xy }, set] = useSpring(() => ({ xy: [0, 0] }));
  const [itemHeight, setItemHeight] = useState(null);
  const [itemWidth, setItemWidth] = useState(null);

  const navigate = useNavigate();

  const scrollIfNeeded = (event) => {
    const container = containerRef.current;
    const rect = container.getBoundingClientRect();

    if (event.clientX < rect.left + SCROLL_THRESHOLD) {
      container.scrollLeft -= SCROLL_SPEED;
    } else if (event.clientX > rect.right - SCROLL_THRESHOLD) {
      container.scrollLeft += SCROLL_SPEED;
    }

    if (event.clientY < rect.top + SCROLL_THRESHOLD) {
      container.scrollTop -= SCROLL_SPEED;
    } else if (event.clientY > rect.bottom - SCROLL_THRESHOLD) {
      container.scrollTop += SCROLL_SPEED;
    }
  };

  const handleTouchMove = (event) => {
    if (isDragging) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (scrollControl.active) {
    }
  }, [scrollControl]);

  const bind = useGesture(
    {
      onClick: (v) => {
        // alert("touch start")
      // navigate(`/create-booking/${item.id}`);
        v.event.preventDefault()  
        v.event.stopPropagation();
      console.log("on click gesture", v);
      },

      onTouchStart: (v) => {
 
        setUnderTap(true);
      },

  

      onDragStart: (event) => {

        try{
          console.log("onDragStart", event);
          //console.log("itemWidth  itemHeight ", itemWidth, itemHeight);
          //event.dataTransfer.setData("text/plain", "ElementoB");
          setUnderTap(true);
          setIsDragging(true);
          setLeftScrollOnInit(divContenedor.scrollLeft);
          // setTopScrollOnInit(divContenedor.scrollTop)
          setTopScrollOnInit(divContenedorRoot.scrollY);
  
          console.log(
            "AAARRR   onDragStart",
            divContenedor.scrollLeft,
            divContenedorRoot.scrollY
          );
  
          setDimensionesCaja({
            w: document.getElementById("contenedorSizeCalc")
              .clientWidth,
            h: document.getElementById("contenedorSizeCalc")
              .clientHeight,
          });
  
          console.log("after filled", dimensionesCaja);
        }catch(e){
          console.log("onDragStart error", e)
          alert("onDragStart error")
        }


        // console.log("onDragStart setLeftScrollOnInit", divContenedor.scrollLeft)
      },

      onDragEnd: (v) => {

            try{
              console.log("onDragEnd");
              //  v.event.preventDefault();
              // v.event.stopPropagation();
              // console.log("------------------------------------->>>>>>>>   onDragEnd", v);
              setUnderTap(false);
              setIsDragging(false);
              setLayer(1);
              onMoveEnd();
              set({ reset: true });
              setScrolling((p) => {
                // console.log("INTERVALsetScrolling previous", p)
                if (p) {
                  // console.log("*************  CLEAR INTERVAL SCROLLING onDragEnd *************", p)
                  clearInterval(p);
                }
                return null;
              });
              onMoveStart(null, null);
            } catch(e){
              console.log("onDragEnd error", e)
              alert("onDragEnd error")
            } 
      },

      onDrag: (evt) => {

            try{
                  const innerWidthScreen = window.innerWidth;
                  const innerHeightScreen = window.innerHeight;
                  const { down, movement, event, tap, velocity, elapsedTime } =
                    evt;
          
          
                    event.preventDefault();
          
                  if (elapsedTime < 500) return;
          
                  setUnderTap(false);
          
                  // const boundsContenedorAgenda =divContenedor.getBoundingClientRect()
                  // console.log(  "evt", evt );
                  //  console.log("evt bound contAgnd",
                  //     {
                  //       xAgenda: boundsContenedorAgenda.x,
                  //       yAgenda: boundsContenedorAgenda.y,
                  //       absX : event.clientX-boundsContenedorAgenda.x,
                  //       absY : event.clientY-boundsContenedorAgenda.y,
                  //     })
          
                  // console.log("evt bound contAgnd  Y = ",  movement[1],   event.clientY-boundsContenedorAgenda.y-67,
                  //     Math.floor( (event.clientY-boundsContenedorAgenda.y)/67 )  )
          
                  // const absItemY = (item.from*67)+movement[1]
                  // console.log("contAgnd  abs", absItemY, Math.trunc(absItemY/67),   Math.floor(absItemY/67) )
          
                  //  console.log("evt event offsetX", event.nativeEvent )
          
                  const cursorX = event.clientX;
                  const cursorY = event.clientY;
                  const targetDiv = event.target;
                  // Obtener las coordenadas del div en relación con la ventana del navegador
                  const targetDivRect = targetDiv.getBoundingClientRect();
                  const divX = targetDivRect.left;
                  const divY = targetDivRect.top;
          
                  //  // Calcular la posición del cursor con respecto al div
                  //  const relativeX = cursorX - divX;
                  //  const relativeY = cursorY - divY;
                  //  console.log(`getBoundingClientRect Posición del cursor con respecto al div: X=${relativeX}, Y=${relativeY}`);
          
                  // const innerWidth = window.innerWidth;
          
                  if (evt.dragging) {
                  }
          
                  // console.log("innerWidthScreen", evt.xy[0], innerWidthScreen )
          
                  //   if ( (evt.xy[0] > (innerWidthScreen - 100) ) && !scrolling  ) {
          
                  //     let contador = 0;
          
                  //     const interval = setInterval(() => {
                  //       divContenedor.scrollBy({
                  //         left: 20,
                  //         behavior: "instant",
                  //       });
          
                  //       console.log("scroll interval movement[0]", movement[0], set )
                  //       console.log("scroll interval contador", contador, )
          
                  //       contador++;
                  //       setContadorScroll((p)=>p+1)
          
                  //       // set({
                  //       //   // delay: 0,
                  //       //   immediate:true,
                  //       //   x:  movement[0]+(20*contador),
                  //       // });
          
                  //     }, 1000);
                  //     setScrolling(interval)
                  //     console.log("++++++++++++++  SET INTERVAL SCROLLING ++++++++++++++", interval)
                  //     console.log("++++++++++++++  ZONA SCROLLING ++++++++++++++")
                  //   }else{
                  //     console.log("!!!!!!!!!!!!!!  FUERA DE ZONA SCROLLING !!!!!!!!!!!!!!")
                  //     if(scrolling){
                  //       console.log("*************  CLEAR INTERVAL SCROLLING *************",scrolling)
                  //       clearInterval(scrolling)
                  //       setScrolling(null)
                  //       setContadorScroll(0)
                  //     }
                  //   }
          
                  setLayer(100);
          
                  if (tap) {
                    console.log("TAP   /create-booking/:id");
                    return;
                  }
          
                  // console.log(" DETECCION", movement[1], itemHeight, item.duration )
          
                  // setRowIndex(Math.floor(movement[1] / ((itemHeight) + 16)));
                  //setRowIndex(  Math.floor(movement[1] / 67  )  );
                  // setRowIndex(  Math.floor( (event.clientX-boundsContenedorAgenda.x-65)   / 67  )  );
                  // setRowIndex( (event.clientY-boundsContenedorAgenda.y)/67   );
                  // setRowIndex(  Math.trunc(absItemY/67) );
          
                  // console.log("SCROLL LEFT POSITIVO",{
                  //   dimensionesCaja,
                  //   scrollLeft: divContenedor.scrollLeft,
                  //   clientWidth: divContenedor.clientWidth,
                  //   scrollWidth: divContenedor.scrollWidth,
          
                  //   ancho: document.getElementById("contenedorSizeCalc").scrollWidth,
                  //   alto: document.getElementById("contenedorSizeCalc").scrollHeight,
          
                  //   ancho2: document.getElementById("contenedorSizeCalc").clientWidth,
                  //   alto2: document.getElementById("contenedorSizeCalc").clientHeight,
          
                  //   z: document.getElementById("contenedorSizeCalc")
                  // })
          
          
                  const scrollBehavior = 'instant' // 'smooth' // 'instant' // 'auto'
          
          
                  //if (evt.dragging)
                  {
                    let scrolleo = false;
                    const K_SCROLL_ADD = 16; // 5; //12
                    let adicion = 0;
                    let adicionY = 0;
          
                    if (evt.xy[0] > innerWidthScreen - 60) {
                      let add = 0;
                      if (
                        document.getElementById("contenedorSizeCalc")
                          .scrollWidth <=
                        document.getElementById("contenedorSizeCalc")
                          .clientWidth
                      )
                        add = K_SCROLL_ADD;
                      else add = 0;
          
                      divContenedor.scrollBy({
                        left: add,
                        behavior: scrollBehavior,
                      });
                      scrolleo = true;
                    }
                    if (evt.xy[0] > 0 && evt.xy[0] < 90) {
                      // console.log("SCROLL LEFT NEGATIVO")
                      divContenedor.scrollBy({
                        left: 0 - K_SCROLL_ADD,
                        behavior: scrollBehavior,
                      });
                      scrolleo = true;
                    }
          
                    if (leftScrollOnInit != divContenedor.scrollLeft) {
                      // console.log("leftScrollOnInit !=  divContenedor.scrollLeft", leftScrollOnInit, divContenedor.scrollLeft)
                      if (leftScrollOnInit < divContenedor.scrollLeft)
                        adicion = divContenedor.scrollLeft;
                      if (leftScrollOnInit >= divContenedor.scrollLeft)
                        adicion = divContenedor.scrollLeft - leftScrollOnInit;
                    }
          
                    console.log(
                      "AAARRR   evt",
                      evt,
                      innerWidthScreen,
                      innerHeightScreen,
                      evt.xy[0],
                      evt.xy[1]
                    );
                    console.log(
                      "AAARRR divContenedorRoot.scrollTop",
                      divContenedorRoot.scrollY
                    );
          
                    if (evt.xy[1] > innerHeightScreen - 60) {
                      console.log("AAARRR  scroll + TOP");
          
                      let add = 0;
                      if (
                        document.getElementById("contenedorSizeCalc")
                          .scrollHeight <=
                        document.getElementById("contenedorSizeCalc")
                          .clientHeight
                      )
                        add = K_SCROLL_ADD;
                      else add = 0;
          
                      add = K_SCROLL_ADD;
          
                      // console.log("AAARRR  scroll + TOP")
                      // divContenedor.scrollBy({
                      //   top: add,
                      //   behavior: scrollBehavior,
                      // });
                      divContenedorRoot.scrollBy({
                        top: add,
                        behavior: scrollBehavior,
                      });
                      scrolleo = true;
                    }
                    if (evt.xy[1] > 0 && evt.xy[1] < 280) {
                      console.log("AAARRR  scroll - TOP");
                      // divContenedor.scrollBy({
                      //   top: 0-K_SCROLL_ADD,
                      //   behavior: scrollBehavior,
                      // });
          
                      divContenedorRoot.scrollBy({
                        top: 0 - K_SCROLL_ADD,
                        behavior: scrollBehavior,
                      });
          
                      scrolleo = true;
                    }
          
                    if (topScrollOnInit != divContenedorRoot.scrollY) {
                      // console.log("topScrollOnInit !=  divContenedor.scrollTop", topScrollOnInit, divContenedor.scrollTop)
                      if (topScrollOnInit < divContenedor.scrollTop)
                        adicionY = divContenedorRoot.scrollY;
                      if (topScrollOnInit >= divContenedorRoot.scrollY)
                        adicionY = divContenedorRoot.scrollY - topScrollOnInit;
                    }
          
                    console.log(
                      "AAARRR  divContenedorRoot.scrollY",
                      divContenedorRoot.scrollY
                    );
          
                    // if(scrolleo){
                    //   event.preventDefault(); // Evita el movimiento del elemento arrastrado mientras se hace scroll
                    // }else{
                    //   // console.log("adicionar",   adicion , evt )
                    //   console.log("TRY3 movement", movement,  divContenedor.scrollTop, itemHeight*item.duration )
                    //   set({
                    //     immediate:true,
                    //     xy: down ? [movement[0]+(adicion), movement[1]+(adicionY)-472-(itemHeight*item.duration)  ] : [0, 0],
                    //   });
                    // }
                    /// -472  con scroll 300  calza bien
          
                    // const offset = ( -472-(itemHeight*item.duration) )
                    const offsetX = divContenedor.scrollLeft - leftScrollOnInit;
                    const offsetY = divContenedorRoot.scrollY - topScrollOnInit;
          
                    // console.log("TRY3 movement", movement,  divContenedor.scrollTop, itemHeight*item.duration, adicionY, offsetY )
          
                    set({
                      immediate: true,
                      // xy: down ? [movement[0]+(adicion), movement[1]+(adicionY)+offset ] : [0, 0],
                      xy: down
                        ? quantizeBy([   movement[0] + offsetX,   movement[1] + offsetY    ], K_SCROLL_ADD)
                        : [0, 0],
                    });
          
                    // console.log("aaa", divContenedor.scrollHeight, divContenedor.clientHeight, divContenedor.scrollTop)
          
                    // adicionY=adicion=0;
          
                    onMoveStart(
                      item,
                      Math.floor((movement[1] + offsetY) / (itemHeight + 3)), // Math.trunc(absItemY/67),
                      Math.floor(
                        (movement[0] + itemWidth + offsetX) / (itemWidth + 3)
                      )
                    );
                  }
            }catch(e){
              console.log("onDrag error", e)
              alert("onDrag error")
            }


      },
    },
    {
      enabled: item.used,
      drag: {
        threshold: 5,
        filterTaps: true,
        //  delay:800,
        // preventScroll:800,
      },
      //  threshold: 100,
      // delay:true,
      // preventDefault:true,
      // filterTaps:true,
      // tapsThreshold:10,
      // pointer:{
      //   touch:true,
      //   lock:true
      // }
    }
  );

  useEffect(() => {
    // console.log("use effect  item.duration", {
    //   "itemRef.current.offsetHeight":
    //     itemRef.current.offsetHeight / item.duration,
    //   "item.duration": item.duration,
    // });

    setItemHeight(itemRef.current.offsetHeight / item.duration);
    setItemWidth(itemRef.current.offsetWidth);
  }, [item.duration]);
  

  const hexToRgb = (hex) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return { r, g, b };
  };

  const makeColorDarker = (color, factor) => {
    const { r, g, b } = hexToRgb(color);
    const newR = Math.max(0, r - factor);
    const newG = Math.max(0, g - factor);
    const newB = Math.max(0, b - factor);
    return `rgb(${newR}, ${newG}, ${newB})`;
  };

  const { locationItem } = useContext(CurrentDateContext);

  let bgColorMod = bgColor;
  let darkerColor = makeColorDarker(bgColor, 40);

  if (underTap) bgColorMod = "#FFC107";

  return (
    <>
      {/* <div
        className={`fixed z-50 top-0 right-0 h-screen w-8 bg-red-500/20`}
      ></div>

      <div className="fixed z-[50] top-0 left-[35px] h-screen w-8 bg-red-500/20"></div> */}

      <div
        className={`rounded-md relative  ${
          isDragging ? "transparent z-[200]" : "z-10"
        }`}
        style={{
          backgroundColor: bgColorMod,
          zIndex: layer,
          gridRow: `span ${item.duration} / span ${item.duration}`,
        }}
      onClick={() => navigate(`/create-booking/${item.id}`)}
      >
        {locationItem.id !== item.locationId && (
          <div className="absolute top-0 left-0 z-50 rounded-md bg-neutral-50/70 w-full h-full"></div>
        )}

        <animated.div
          className={`flex  h-full    ${
            item.type === "used" ? "cursor-move" : "cursor-move"
          } `}
          style={{
            zIndex: layer,
            gridRow: `span ${item.duration} / span ${item.duration}`,
            transform: xy.to(
              (x, y) => `translate3d(${x}px, ${y}px, 0)`
            ),
          }}
          ref={itemRef}
        >
          <div
            className={`relative w-[140px] ${
              isDragging ? "" : "p-[10px]"
            }`}
          >
            <div
              className={`  hover:bg-transparent active:bg-transparent focus:bg-transparent
                grid place-items-center touch-none absolute top-2 right-2 w-12 h-[52px] z-50`}
              style={
                {
                  // touchAction:'auto',
                  // backgroundColor: 'orange',
                }
              }
              {...bind()}
            >
              <div
                className={`grid  place-items-center rounded-md touch-none absolute top-0 right-0 w-6 h-7 z-50`}
                // style={{
                //   backgroundColor: darkerColor,
                // }}
              >
                <svg
                  width="12"
                  height="20"
                  viewBox="0 0 12 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.84615 15.7696C2.21129 15.7696 2.56822 15.8779 2.87182 16.0807C3.17542 16.2836 3.41205 16.5719 3.55178 16.9093C3.69151 17.2466 3.72807 17.6178 3.65684 17.9759C3.5856 18.334 3.40977 18.663 3.15158 18.9212C2.89339 19.1794 2.56444 19.3552 2.20632 19.4264C1.8482 19.4977 1.477 19.4611 1.13966 19.3214C0.802322 19.1817 0.513992 18.945 0.311134 18.6414C0.108276 18.3378 9.94883e-07 17.9809 9.94883e-07 17.6158C9.94883e-07 17.1261 0.194506 16.6566 0.540727 16.3103C0.886948 15.9641 1.35652 15.7696 1.84615 15.7696ZM9.94883e-07 9.76961C9.94883e-07 10.1347 0.108276 10.4917 0.311134 10.7953C0.513992 11.0989 0.802322 11.3355 1.13966 11.4752C1.477 11.615 1.8482 11.6515 2.20632 11.5803C2.56444 11.5091 2.89339 11.3332 3.15158 11.075C3.40977 10.8168 3.5856 10.4879 3.65684 10.1298C3.72807 9.77165 3.69151 9.40045 3.55178 9.06311C3.41205 8.72577 3.17542 8.43744 2.87182 8.23459C2.56822 8.03173 2.21129 7.92345 1.84615 7.92345C1.35652 7.92345 0.886948 8.11796 0.540727 8.46418C0.194506 8.8104 9.94883e-07 9.27998 9.94883e-07 9.76961ZM3.69231 1.92345C3.69231 1.55832 3.58403 1.20138 3.38118 0.897784C3.17832 0.594186 2.88999 0.35756 2.55265 0.217829C2.21531 0.0780982 1.84411 0.0415382 1.48599 0.112772C1.12787 0.184007 0.798916 0.359836 0.540727 0.618026C0.282538 0.876215 0.106708 1.20517 0.0354742 1.56329C-0.0357601 1.92141 0.000799903 2.29261 0.140531 2.62995C0.280262 2.96729 0.516888 3.25562 0.820487 3.45847C1.12409 3.66133 1.48102 3.76961 1.84615 3.76961C2.33579 3.76961 2.80536 3.5751 3.15158 3.22888C3.4978 2.88266 3.69231 2.41308 3.69231 1.92345ZM8.30769 17.6158C8.30769 17.9809 8.41597 18.3378 8.61883 18.6414C8.82168 18.945 9.11001 19.1817 9.44735 19.3214C9.78469 19.4611 10.1559 19.4977 10.514 19.4264C10.8721 19.3552 11.2011 19.1794 11.4593 18.9212C11.7175 18.663 11.8933 18.334 11.9645 17.9759C12.0358 17.6178 11.9992 17.2466 11.8595 16.9093C11.7197 16.5719 11.4831 16.2836 11.1795 16.0807C10.8759 15.8779 10.519 15.7696 10.1538 15.7696C9.66422 15.7696 9.19464 15.9641 8.84842 16.3103C8.5022 16.6566 8.30769 17.1261 8.30769 17.6158ZM8.30769 9.76961C8.30769 10.1347 8.41597 10.4917 8.61883 10.7953C8.82168 11.0989 9.11001 11.3355 9.44735 11.4752C9.78469 11.615 10.1559 11.6515 10.514 11.5803C10.8721 11.5091 11.2011 11.3332 11.4593 11.075C11.7175 10.8168 11.8933 10.4879 11.9645 10.1298C12.0358 9.77165 11.9992 9.40045 11.8595 9.06311C11.7197 8.72577 11.4831 8.43744 11.1795 8.23459C10.8759 8.03173 10.519 7.92345 10.1538 7.92345C9.66422 7.92345 9.19464 8.11796 8.84842 8.46418C8.5022 8.8104 8.30769 9.27998 8.30769 9.76961ZM8.30769 1.92345C8.30769 2.28859 8.41597 2.64552 8.61883 2.94912C8.82168 3.25272 9.11001 3.48935 9.44735 3.62908C9.78469 3.76881 10.1559 3.80537 10.514 3.73413C10.8721 3.6629 11.2011 3.48707 11.4593 3.22888C11.7175 2.97069 11.8933 2.64174 11.9645 2.28362C12.0358 1.9255 11.9992 1.5543 11.8595 1.21696C11.7197 0.879619 11.4831 0.59129 11.1795 0.388432C10.8759 0.185574 10.519 0.0772993 10.1538 0.0772993C9.66422 0.0772993 9.19464 0.271805 8.84842 0.618026C8.5022 0.964247 8.30769 1.43382 8.30769 1.92345Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>

            <div
              className={`h-full ${isDragging ? "p-[10px]" : ""}`}
              style={{
                backgroundColor: bgColorMod,
              }}
            >
              {children}
            </div>
          </div>
        </animated.div>
      </div>
    </>
  );
}

const WorkItemColumn = ({
  calendario,
  work,
  dirtyData,
  rowPropuesto,
  workIndex,
  onMoveStart,
  onMoveEnd,
  containerRef,
  fastAdd,
  hasChangeBooking,
  setLoaderDriverHoursPerDay,
  setIsScrolling,
  setElementCoords,
  principalContentRef,
}) => {
  const apolloClient = useApolloClient();

  const { currentDate, locationItem } = useContext(
    CurrentDateContext
  );
  const [data, setData] = useState(null);

  useEffect(() => {
    // setLoaderDriverHoursPerDay(true);
    // refreshDriversCount();
    refreshDriversLocalCount();
  }, [work]);

  const refreshDriversLocalCount = async () => {
    setData({
      minutesPerDayOfDriver: work.reservas
        .filter((i) => i.type === "used")
        .reduce((a, b) => a + parseInt(b.duration * 30), 0),
    });
  };

  // const refreshDriversCount = async () => {
  //   apolloClient
  //     .query({
  //       fetchPolicy: "network-only",
  //       query: GET_COUNT_PER_DAY_EMPLOYEE,
  //       variables: {
  //         locationId: +locationItem?.id,
  //         date: dayjs(currentDate).format(),
  //         employeeId: work?.driverObj.id,
  //       },
  //     })
  //     .then((res) => {
  //       setLoaderDriverHoursPerDay(false);
  //       setData(res?.data);
  //       console.log("refreshDriversLocalCount data", res?.data)
  //     })
  //     .catch((error) => {
  //       setLoaderDriverHoursPerDay(false);
  //       setData(error);
  //     });
  // };

  return (
    <div className="flex  " key={work.driver}>
      <div className="flex flex-col gap-[7px] w-[140px] ">
        <div className="relative top-0 h-[45px]">
          <div
            className="overflow-hidden left-0 w-[140px] h-full grid items-center pl-12 uppercase font-bold border-2 rounded-md border-l-0"
            style={{
              minWidth: "140px",
              borderColor: work.color,
              color: work.color,
            }}
          >
            <div
              className="absolute rounded-tl-md rounded-bl-md top-0 left-0 w-9 h-full grid place-items-center"
              style={{ backgroundColor: work.color }}
            >
              <p className="text-white font-medium text-sm">
                {data?.minutesPerDayOfDriver
                  ? data?.minutesPerDayOfDriver / 60
                  : "..."}
              </p>
            </div>
            {work.driver}
          </div>
        </div>

        <div className="flex justify-center h-full ">
          <div
            className={`grid  gap-[7px]   w-full h-full  mb-8 `}
            style={{
              // height: "2080px",
              gridTemplateRows: `repeat(${K_MAX_BLOQUES}, 60px)`,
            }}
          >
            {work.reservas.map((item, itemIndex) => {
              let bgColor = "#cccccc";
              let height;

              let opacity = 1;

              if (
                rowPropuesto &&
                rowPropuesto.valid &&
                rowPropuesto.item.id === item.id
              ){
                bgColor = "#FFC107";
                opacity = 1;
              }
              else if (item.type === "used") {
                if (item.bookingType === "CLEANING")
                  bgColor = "#616161";
                else bgColor = item.color;
              }

              if (
                rowPropuesto &&
                rowPropuesto.valid &&
                item.type !== "used" &&

                checkOnTheFly(rowPropuesto,calendario ) &&

                // (checkOverlap2(
                //   {
                //     from: rowPropuesto.newFrom,
                //     duration: rowPropuesto.item.duration,
                //   },
                //   rowPropuesto.item.driver,
                //   calendario[rowPropuesto.newDriverIndex].driver,
                //   rowPropuesto.item.id,
                //   calendario
                // ) ==  0)   &&


                ( 
                  (rowPropuesto.rowIndex <= item.from ) 
                  &&
                 (      (item.from) <= (rowPropuesto.item.duration+rowPropuesto.rowIndex-1)    )
                ) &&
                rowPropuesto.colIndex === workIndex
              )
                bgColor = "#FFC107" //"red";
              
                if (
                  rowPropuesto &&
                  rowPropuesto.valid &&
                  item.type !== "used" &&
  
                  !checkOnTheFly(rowPropuesto,calendario ) &&

                  // (checkOverlap2(
                  //   {
                  //     from: rowPropuesto.newFrom,
                  //     duration: rowPropuesto.item.duration,
                  //   },
                  //   rowPropuesto.item.driver,
                  //   calendario[rowPropuesto.newDriverIndex].driver,
                  //   rowPropuesto.item.id,
                  //   calendario
                  // ) !==  0)   &&
  
  
                  ( 
                    (rowPropuesto.rowIndex <= item.from ) 
                    &&
                   (      (item.from) <= (rowPropuesto.item.duration+rowPropuesto.rowIndex-1)    )
                  ) &&
                  rowPropuesto.colIndex === workIndex
                ) bgColor = "red";




                height = 127;

              return item.type === "used" ? (
                <DraggableItem
                opacity={opacity}
                  height={height}
                  fastAdd={fastAdd}
                  setElementCoords={setElementCoords}
                  setIsScrolling={setIsScrolling}
                  onMoveStart={onMoveStart}
                  onMoveEnd={onMoveEnd}
                  item={item}
                  key={item.id}
                  containerRef={containerRef}
                  bgColor={bgColor}
                  principalContentRef={principalContentRef}
                >
                  <Card
                    dirtyData={dirtyData}
                    row={itemIndex}
                    col={workIndex}
                    item={item}
                    rowPropuesto={rowPropuesto}
                  />
                </DraggableItem>
              ) : (
                <Card
                  fastAdd={fastAdd}
                  key={item.id}
                  row={itemIndex}
                  col={workIndex}
                  item={item}
                  rowPropuesto={rowPropuesto}
                  backGColor={bgColor}
                  />

              );
            })}
          </div>
        </div>
      </div>

      <div className="w-[7px] h-full"></div>
    </div>
  );
};

function Poc({
  reservas,
  handleDirty,
  setDirtyData,
  fastAdd,
  dirtyData,
  hasChangeBooking,
  setLoaderDriverHoursPerDay,
  setIsScrolling,
  setElementCoords,
  principalContentRef,
  principalContentHeaderRef,
  setHasChangeBooking,
}) {
  const containerRef = useRef(null);
  const { globalData } = useAuthContext();
  const { infoDnd, setInfoDnd } = useContext(InfoDndContext);

  const [rowPropuesto, setRowPropuesto] = useState({ valid: false });
  const [state, setState] = useState({ items });

  const [agendamientos, setAgendamientos] = useState([]);
  const [calendario, setCalendario] = useState([]);

  useEffect(() => {
    if (reservas) {
      setAgendamientos(cloneDeep(reservas));
    } else {
      setAgendamientos(reservasInitial);
    }
  }, [reservas]);

  useEffect(() => {
    //   setTimeout(() => {

    //   const divContenedor = document.getElementById('contenedorAgenda');

    //   if(divContenedor)  divContenedor.scrollBy({
    //     top: 300,
    //     behavior: scrollBehavior,
    //   });
    // }, 1000);

    // setCalendario con un array de los agendamientos agrupados por driver, ejemplo: [ { driver:"Adam", reservas:[...] }, { driver:"Bob", reservas:[...] } ]
    const grouped = agendamientos.reduce((acc, agendamiento) => {
      const driver = acc.find(
        (driver) => driver.driver === agendamiento.driver
      );
      if (driver) driver.reservas.push(agendamiento);
      else
        acc.push({
          driverObj: agendamiento.driverObj,
          driver: agendamiento.driver,
          color: agendamiento.color,
          reservas: [agendamiento],
        });
      return acc;
    }, []);

    console.log("grouped", grouped);

    //  const filled, recorrer todos los items de grouped y remplazar items por el retorno de fillColumn(items,12,1)
    const filled = grouped
      .sort((a, b) => a.driverObj.id - b.driverObj.id)
      .map((driver) => {
        console.log("map grouped driver", driver);
        const filled = fillColumn(
          driver.reservas,
          K_MAX_BLOQUES,
          1,
          driver
        );
        // console.log("filled", filled);
        const reservasWithUsed = calcNextUsed(filled);
        console.log("reservasWithUsed", reservasWithUsed);

        return {
          driverObj: driver.driverObj,
          driver: driver.driver,
          color: driver.color,
          reservas: reservasWithUsed,
        };
      });

    // console.log("filled", JSON.stringify(filled[1]));

    setCalendario(filled);
  }, [agendamientos]);

  function countBlanksUntilUsed(data, startIndex) {
    let count = 0;
    for (let i = startIndex + 1; i < data.length; i++) {
      if (data[i].type === "used") {
        break;
      } else if (data[i].type === "blank") {
        count++;
      }
    }
    return count;
  }

  const calcNextUsed = (data) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].type === "blank") {
        const nextUsedCount = countBlanksUntilUsed(data, i);
        data[i].nextUsed = nextUsedCount;
      }
    }

    return data;
  };

  const onDragEnd = (result) => {
    console.log("dragEnd", result);

    if (!result.destination) {
      return;
    }

    const items = reorder(
      state.items,
      result.source.index,
      result.destination.index
    );

    setState({ items });
  };

  const reorder = (list, startIndex, endIndex) => {
    const [removed] = list.splice(startIndex, 1);
    list.splice(endIndex, 0, removed);

    return list;
  };

  const onMoveStart = (item, rowIndex, colIndex, driverDestino) => {
    // console.log("infoDnd",{
    //   infoDnd,
    //   item, rowIndex, colIndex, driverDestino
    // })

    // if (infoDnd) {   // OJO, provoca multiples renderizados
    //   setInfoDnd({
    //     ...infoDnd,
    //     wa_moved: true,
    //   });
    // }

    console.log("item.driver", item);

    const currentDriverIndex = calendario.findIndex(
      (driver) => driver.driver === item?.driver
    );
    let newDriverIndex = currentDriverIndex + colIndex;

    // console.log({ driverDestino });

    if (newDriverIndex < 0) newDriverIndex = 0;
    if (newDriverIndex > calendario.length - 1)
      newDriverIndex = calendario.length - 1;

    if (item)
      setRowPropuesto({
        rowIndex: item.from + rowIndex,
        colIndexOriginal: currentDriverIndex,
        colIndex: newDriverIndex,
        item,
        newFrom: item.from + rowIndex,
        newDriverIndex: newDriverIndex,
        valid: true,
      });
  };

  const onMoveEnd = () => {
    // console.log("row Propuesto", rowPropuesto);

    // setInfoDnd({  // OJO, provoca multiples renderizados
    //   ...infoDnd,
    //   wa_moved: false,
    // });

    if (rowPropuesto.newFrom >= 0) {
      console.log("rowPropuesto", rowPropuesto);

      const driver = calendario[rowPropuesto.newDriverIndex].driver;
      const driverObj =
        calendario[rowPropuesto.newDriverIndex].driverObj;

      // console.log("onMoveEnd", rowPropuesto.item.driversAdicionales);

      let test = false;
      setHasChangeBooking(!hasChangeBooking);


      const co2= checkOverlap2(
        {
          from: rowPropuesto.newFrom,
          duration: rowPropuesto.item.duration,
        },
        rowPropuesto.item.driver,
        driver,
        rowPropuesto.item.id,
        calendario
      )

        if(co2<0){
          test = true
          procesarNotificaciones(toast, co2)
        }


      if (rowPropuesto.item.driversAdicionales.length > 0) {
        console.log(
          "TIENE DRIVERS ADICIONALES",
          rowPropuesto.item.driversAdicionales,
          rowPropuesto
        );
        if (
          rowPropuesto.colIndexOriginal !==
          rowPropuesto.newDriverIndex
        ) {
          setRowPropuesto({ valid: false });
          return;
        }
      }

      rowPropuesto.item.driversAdicionales.map((i) => {

          const res = checkOverlap2(
            {
              from: rowPropuesto.newFrom,
              duration: rowPropuesto.item.duration,
            },
            rowPropuesto.item.driver,
            i.name,
            rowPropuesto.item.id,
            calendario
          );

          console.log("res", res)

          if(res<0){
            test = true
            procesarNotificaciones(toast, res)
          }

      });



      



      if (test==0) {
        console.log("no hay overlap");
        const newAgendamientos = agendamientos.map((agendamiento) => {
          const newItem = {
            ...agendamiento,
            from: rowPropuesto.newFrom,
            modified: true,
            // driver
          };

          // console.log("newItem.driver", newItem.driver);
          // console.log("driver", driver);

          if (rowPropuesto.item.driversAdicionales.length == 0) {
            newItem.driverObj = driverObj;
            newItem.driver = driver;
            newItem.color = driverObj.bgColor;
          }

          if (agendamiento.id === rowPropuesto.item.id)
            return newItem;
          else return agendamiento;
        });

        const passed = marcadorDeBoatCollisions(newAgendamientos);

        console.log(
          "newAgendamientos passed",
          driverObj,
          passed,
          JSON.stringify(passed)
        );

        handleDirty(true);
        setAgendamientos(passed);
        setDirtyData(passed);
      }
    }

    setRowPropuesto({ valid: false });
  };



  // // funcion que chequea si el itemPropuesto se solapa con algun item del calendario de un driver teniendo en cuenta el from y el duration de los items buscados y que no se el mismo id
  // const checkOverlap = (itemPropuesto, driver, newDriver, id) => {
  //   const filled = calendario.find(
  //     (driverReservas) => driverReservas.driver === newDriver
  //   ).reservas;

  //   const driverReservas = filled.filter(
  //     (reserva) => reserva.type === "used" && reserva.id !== id
  //   );

  //   console.log("reservas", driver, driverReservas);

  //   const { from, duration } = itemPropuesto;
  //   const endOrigin = from + duration;

  //   if (endOrigin > K_MAX_BLOQUES) {
  //     const notify = () =>
  //       toast("Reservations cannot be moved past closing", {
  //         icon: "⚠️",
  //       });
  //     notify();
  //     return true;
  //   }

  //   const fullTest = driverReservas.filter((i) => {
  //     const f = i.from;
  //     const t = i.from + i.duration;
  //     // is  "from" between  f and t ?
  //     return (
  //       (f <= from && t > from) ||
  //       (f < endOrigin && t > endOrigin) ||
  //       (f > from && t < endOrigin) ||
  //       (f > from && t <= endOrigin)
  //     );
  //   });

  //   console.log("============== TEST fullTest", fullTest);
  //   setInfoDnd({ driver: newDriver, hour: rowPropuesto.newFrom });

  //   console.log("here");
  //   if (fullTest.length) {
  //     const notify = () =>
  //       toast("Booking collision!", {
  //         icon: "⚠️",
  //       });
  //     notify();
  //     return true;
  //   }

  //   return false;
  // };

  const calcSideGrid = () => {
    let times = [];

    const base = dayjs().hour(6).minute(0);

    for (let i = 0; i < 12; i++) {
      times.push({
        id: i,
        start: base.add(60 * i, "minute").format("hh A"),
      });

      base.add(60, "minute");
    }
    return times;
  };

  const TIMES = calcSideGrid();

  return (
    <div className=" w-full">
      {/* <div className="bg-green-200 px-3">
  horas
</div> */}

      <div
        id="contenedorSizeCalc"
        className=" flex"
        ref={containerRef}
      >
        {calendario.map((work, workIndex) => {
          return (
            <WorkItemColumn
              dirtyData={dirtyData}
              calendario={calendario}
              setElementCoords={setElementCoords}
              setIsScrolling={setIsScrolling}
              setLoaderDriverHoursPerDay={setLoaderDriverHoursPerDay}
              hasChangeBooking={hasChangeBooking}
              key={workIndex}
              work={work}
              rowPropuesto={rowPropuesto}
              workIndex={workIndex}
              onMoveStart={onMoveStart}
              onMoveEnd={onMoveEnd}
              containerRef={containerRef}
              fastAdd={fastAdd}
              principalContentRef={principalContentRef}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Poc;
